import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'
import React from 'react'

export const AppMotorPrivacy: React.FC = () => {

    const data = [
        {
            'type': 2,
            'content': 'At SHENMA Credit, we value your privacy and strive to protect your personal information in compliance with the Personal Data Protection Act 2010.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit will only collect, record, hold, use, disclose and store (i.e. "process") use your personal information in accordance with the Personal Data Protection Act 2010, this Privacy Notice and the privacy terms in your agreement(s) with SHENMA Credit that you may have contracted with.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'This Privacy Notice explains:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'The type of personal information SHENMA Credit collects and how to collect it.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'How SHENMA Credit uses your personal information.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'The parties that SHENMA Credit disclose the personal information to.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'The choices that SHENMA Credit offers, including how to access and update your personal information.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'For the purposes of this Privacy Notice, please note that:\n“Personal information” refers to any information which relates directly or indirectly to you and/or your transactions with us. This information includes but not limited to your name, date of birth, NRIC number, passport number, home or mailing address, phone number, email address, bank account details, gender, race, nationality, occupation, marital status, financial information such as your income or income tax particulars, credit history, and other information permitted by applicable law. For the avoidance of doubt, please note that this Privacy Notice is applicable only if you are an individual.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'THE TYPE OF PERSONAL INFORMATION SHENMA CREDIT COLLECTS AND HOW TO COLLECT IT',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'In order to enable us to deal with your inquiries and the credit facilities for you and/or to generally provide you with our products and services, we may need to and/or may be required to process personal information and financial information about you. We may obtain this information from yourself and from a variety of sources, including but not limited to:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'through your relationship with us, for example information provided by you in application forms, when using our products or services, when taking part in customer surveys, competitions and promotions, and during financial reviews;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'through your verbal and written communications with us and/or our authorised agents;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'from an analysis of the way you use and manage your account(s)/facility(ies) with us, from the transactions you make and from the payments which are made to your account(s)/facility(ies);',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'from third parties connected with you, such as employers, credit reporting agencies, guarantors, government/statutory agencies, and/or',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'from such other sources in respect of which you have given your consent to disclose information relating to you and/or where not otherwise restricted.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'from any information that is supplied and/or collected when you visit our websites which include your mobile device or computer\'s IP address or from any information that is collected via cookies in some of our websites. We use cookies for a number of purposes, including to store your preference for certain types of information or products, further analysis for the purpose of providing products and services to you, to improve our products and/or to personalize our services to you. You may adjust settings on your browser and/or mobile device so that you will be notified when you receive a cookie or other similar tracking tools. Please refer to your browser documentation to check if the tracking tools have been enabled on your computer and/or mobile device or to request not to receive cookies or to disable cookies if you do not wish to have information collected via the use of cookies.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'HOW SHENMA CREDIT USES YOUR PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'SHENMA Credit may use your personal information for one or more of the following purposes:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to assess your application(s)/request(s) for products and services offered by SHENMA Credit;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to verify your financial standing through credit reference/reporting agencies;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to provide you with information on our and/or third party products, services, offers and/or contests which may be of interest to you and in this respect, to contact you via SMS, phone or mobile device, email, fax, mail, websites or browsers, social media and/or any other appropriate communication channels;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'for the purposes of strategic alliances, cross selling, marketing, and promotions; by other units/department/entities within SHENMA Credit, related companies, our agents and third parties;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to improve our products and services and to develop new products and services;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to notify you about benefits and changes to the features of products and services;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to administer offers, competitions and promotions;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to respond to your enquiries and complaints and to generally resolve disputes;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to update, consolidate and improve the accuracy of our records;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'for audit, compliance and risk management purposes;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to transfer or assign our rights, interests and obligations under any of your agreements with us;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to protect or enforce our rights to recover any debt owing to us;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to conduct anti-money laundering checks; for crime detection, investigation, prevention and prosecution; to comply with any sanction requirements;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to maintain your credit history for present and future reference, if deemed necessary;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'to enforce and/or defend any of our rights; and/or',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'for any other purpose that is required or permitted by any law, regulations, guidelines and/or relevant regulatory authorities.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'DISCLOSURE OF YOUR PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'As a part of providing you with our products and services, SHENMA Credit may be required or need to disclose, disseminate and/or transfer information about you with us to the following third parties:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'companies and/or organisations that act as our agents, affiliates, service providers, business partners, professional advisers, other banks and/or financial institution, within or outside Malaysia, where necessary;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'companies and/or organisations that assist us in processing and/or otherwise fulfilling transactions that you have requested;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'companies and/or organisations that assist us in providing value added services that you have requested;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'companies and/or organisations that provide services to us in communicating our products and services to you;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'any other person notified by you as authorised to give instructions or to use the products or services on your behalf;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'any third party as a result of any restructuring of loan products or services granted to you or the sale of debts, provided that any recipient uses your information for the same purposes as it was originally supplied to us and/or used by us;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'any guarantors for the products or services granted by us to you;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'any person intending to settle any moneys outstanding under the products or services granted by us to you;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'any credit reporting agencies, rating agencies, insurer or insurance broker or direct or indirect provider of credit protection;',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'any person connected to the enforcement or preservation of any of our rights under your agreement(s) with us,You may tell us at any time if you do not wish to receive marketing communications from us, from individual entities within SHENMA Credit and/or from our merchants and strategic partners by notifying us at the address/e-mail address given at the end of this Privacy Notice. Your latest written instructions to us will prevail.',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SECURITY OF YOUR PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'Your Personal Information is our asset and therefore SHENMA Credit places great importance on ensuring the security of your personal information protection. Employees of SHENMA Credit are trained to handle the personal information securely and with utmost respect, failing which they may be subject to disciplinary action.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To ensure information security and privacy at all times, only SHENMA Credit authorised and trained employees have the access to Personal Information provided by you.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'RETENTION OF YOUR PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'SHENMA Credit will retain your personal information in compliance with this Privacy Notice and/or the terms and conditions of your agreement(s) with SHENMA Credit for the duration of your relationship with us, for such period as may be necessary to protect the interests of SHENMA Credit and/or its customers as may be deemed necessary, where otherwise required by the law and/or where required by SHENMA Credit’s relevant policies.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'YOUR OBLIGATION TO SUPPLY PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'It is obligatory to provide your personal information to us to enable us to process your application for our products or services. Should you decline to provide such obligatory personal information, we may not be able to process your application/request or provide you with our products or services.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'YOUR RIGHTS TO ACCESS AND CORRECT YOUR PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'Keeping your data and information accurate and updated is very important to us. You are responsible to ensure that the personal information which you provide to us is accurate, complete, not misleading and that such personal information is kept up to date.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You have the right to access your personal information and you may make a request to us for amendment/correction of your personal information by contacting us through the channel stated below in this notice.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We will use reasonable efforts to comply with your request to access or correct your personal information subject to due verification. Please note that SHENMA Credit may have to withhold access to your personal information in certain situations, for example when we are unable to confirm your identity or where information requested for is of a confidential commercial nature or in the event we receive repeated requests for the same information. Nevertheless, we will notify you of the reasons for not being able to accede to your request.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Please also note that SHENMA Credit may use its discretion in allowing the corrections requested and/or may require further documentary evidence of the new information to avoid fraud and inaccuracy.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'EXERCISING CHOICES OVER THE DISCLOSURE, RETENTION AND USE OF YOUR PERSONAL INFORMATION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'Subject to our contractual rights and obligations under relevant laws and regulations, you may exercise your choice in respect of the disclosure, retention and use of your personal information. Should you wish to do so, kindly contact us at the address/e-mail address given at the end of this Privacy Notice',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'REVISIONS TO PRIVACY NOTICE',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'SHENMA Credit reserves the right to amend this Privacy Notice from time to time. Notice of any such revision will be given on SHENMA Credit’s website at www.shenmacredit.com.my',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'CONTACTING SHENMA CREDIT ABOUT YOUR PERSONAL INFORMATION AND PRIVACY NOTICE',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'Should you have any query in relation to this Privacy Notice or how we handle your personal information, kindly contact us at the following contact points:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit Sdn Bhd\nCustomer Care Unit No. 2, Jalan Muthupalaniappa\n14000 Bukit Mertajam\nPulau Pinang',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Email: wecare@shenmacredit.com.my',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '',
            'paddingLeft': '0px',
            'underline': false
        },
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography style={{ whiteSpace: 'pre-line' }} fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }

    // 文字前有圆点样式
    const bulletItem = (index: number, content: string, paddingLeft: string) => {
        return (
            <Grid key={index} item xs={12} sx={{ mt: '-4px' }}>
                <Typography
                    fontSize={isDesktop ? 18 : 14}
                    color={'#333333'}
                    sx={{
                        paddingLeft: '20px',
                        textIndent: '-16px',
                        paddingRight: '16px',
                        whiteSpace: 'pre-line',
                        lineHeight: 0.8, // 控制文字内部行间距，越小越紧凑
                        '&::before': {
                            content: '"•"',
                            marginRight: '8px',
                            fontSize: '1.5em', // 放大圆点，1.2~1.5之间自己调
                            fontWeight: 'bold', // 加粗，圆点更粗更明显
                        }
                    }}
                >
                    {content}
                </Typography>
            </Grid>
        )
    }
    
    return (
        <Box sx={{
        width: '100%',
        paddingTop: isDesktop ? '60px' : '30px',
        paddingBottom: '60px',
        paddingLeft: isDesktop ? '100px' : '20px',
        paddingRight: isDesktop ? '100px' : '20px',
        }}>
        <Grid container rowSpacing={2}>
            {data.map((item, index) => {
                // 改用函数体，内部写if判断
                if (item.type === 1) {
                    return titleItem(index, item.content, item.paddingLeft, item.underline)
                } else if (item.type === 2) {
                    return contentItem(index, item.content, item.paddingLeft, item.underline)
                } else if (item.type === 3) {
                    return bulletItem(index, item.content, item.paddingLeft)
                }
                // 兜底防止返回undefined
                return null
            })}
        </Grid>
    </Box>
    )
}
